module.exports = __webpack_public_path__ + "static/img/s1.a2e2374.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/s1.png
// module id = DujD
// module chunks = 1